import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class HealthAspectItemColumn extends AbstractChart {
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    type: 'column',
                    height: 180
                },
                legend: {
                    enabled: false
                },
                yAxis: {
                    tickInterval: 50,
                },
                plotOptions: {
                    column: {
                        maxPointWidth: 30,
                        pointWidth: 30,
                    }
                },
                tooltip: {
                    enabled: true,
                    formatter: function () {
                        return `${this.y.toFixed(1)}%`;
                    }
                },
            }
        );
    }
}

export default function () {
    registerPlugin(HealthAspectItemColumn)
}
